import React, { useContext, useState, useEffect, useRef } from 'react'
import CardSwipe from 'react-card-swipe'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import UserContext from '@/product/context/user/userContext'
import { Button } from '@mui/material'
import { LinearProgress } from '@mui/material'
import moment from 'moment'
import { useFormik } from 'formik'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import { dateFormatFrontOnlyDate } from '@/custom/common/components'
import './UserManage.css'
import CustomCommonContext from '../../custom/context/common/commonContext'
import ProductCommonContext from '../../product/context/common/commonContext'
import AlertContext from '@/product/context/alert/alertContext'
import Loaders from '@/product/components/molecules/Loaders'
import AuthContext from '@/product/context/auth/authContext'
import * as Yup from 'yup'
import Cryptos from '../../product/common/cryptos'

const UserManage = (props) => {
    const userContext = useContext(UserContext)
    const authContext = useContext(AuthContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { allCountries, allStates } = useContext(ProductCommonContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const {
        alldata_all_dropdown,
        restockingFeeUpdate,
        responseStatus,
        clearResponse,
    } = customCommonContext
    const {
        user,
        updateProfile,
        responseStatus: responseStatusAuth,
    } = authContext
    const {
        single_user,
        getSingleUser,
        userAction,
        responseStatus: responseStatusUser,
        forgotPassword,
    } = userContext
    const [isLoading, setIsLoading] = useState(false)
    const [swipeData, setSwipeData] = useState(null)

    const [isSwiping, setIsSwiping] = useState(false)
    const [swipedData, setSwipedData] = useState('')
    const swipeDataRef = useRef('')

    const data = props.data
    console.log(`data props `, props)

    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }
    const [category, setCategory] = useState([])
    const [initialLoad, setInitialLoad] = useState(false)
    useEffect(() => {
        if (responseStatus && responseStatus.from === 'restockingFeeUpdate') {
            if (responseStatus.status === 'success') {
                setAlert('Successfully Updated', 'success')
            } else {
                setAlert(
                    responseStatus.message || 'Try after sometimes!',
                    responseStatus.status || 'error'
                )
            }
            changeChangeStatus()
            clearResponse()
        }
    }, [responseStatus])
    const formatPhone = (phone, removeCountryCode = false) => {
        const countryCode = '+1'
        console.log('i am phone start ', phone)
        if (
            removeCountryCode &&
            (phone === '+1' ||
                phone === '1' ||
                phone === '+' ||
                phone === '' ||
                phone === null ||
                phone === '+10' ||
                phone === '0')
        ) {
            phone = ''
        } else if (
            removeCountryCode &&
            typeof phone === 'string' &&
            phone?.length
        ) {
            const regex = /\d+/g
            phone = phone.replace(/^\+?1\s?/, '')
            phone = phone.replace(/^\+/, '')
            const numbersArray = phone?.match(regex)
            const numbersString = numbersArray?.join('')
            phone = parseInt(numbersString, 10)
        } else {
            if (typeof phone === 'string' && !phone?.startsWith('+1')) {
                phone = `${countryCode}${phone}`
            } else {
                phone = `${countryCode}${phone}`
            }
        }
        console.log('i am phone return ', phone)
        return phone
    }

    const validationArray = [
        Yup.object({
            first_name: Yup.string()
                .trim()
                .matches(
                    /^[0-9a-zA-Z]*$/g,
                    'The special characters not allowed'
                )
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            last_name: Yup.string()
                .trim()
                .matches(
                    /^[0-9a-zA-Z\s]*$/g,
                    'The special characters not allowed'
                )
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters'),
            companyname: Yup.string(),
            tax_number: Yup.string(),
            resale_certificate: Yup.array().when('tax_number', {
                is: (end) => end && end.length > 0,
                then: Yup.array().required('Required!'),
            }),
            phone: Yup.string()
                .trim()
                .min(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .max(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .required('Required'),
            additional_phone: Yup.string()
                .trim()
                .nullable()
                .min(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .max(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .when('phone', {
                    is: (value) => value && value.length === 10,
                    then: Yup.string()
                        .nullable()
                        .notOneOf(
                            [Yup.ref('phone')],
                            'Mobile number and additional phone number should not be same'
                        ),
                }),
            address1: Yup.string()
                .trim()
                .matches(
                    /^[0-9a-zA-Z- ,.#()]*$/g,
                    'Some kind of special characters not allowed'
                )
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            country: Yup.string().trim().required('Required'),
            city: Yup.string()
                .trim()
                .matches(/^[0-9a-zA-Z ]*$/g, 'The characters only')
                .required('Required'),
            state: Yup.string().trim().required('Required'),
            zip: Yup.string()
                .trim()
                .matches(/^[0-9]*$/g, 'The positive number only')
                .max(6, 'Maximum 6 characters')
                .required('Required'),
            find_source: Yup.string().trim(),
        }),
    ]

    const formik = useFormik({
        initialValues: {
            id: 0,
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            companyname: '',
            reinstate_days: '',
            reinstate_date: '',
            tax_doc_status: 0,
            restocking_fee_status: 0,
            is_mail_sent: 0,
            resale_certificate: [],
            tax_number: '',
            email_subscribe: false,
            country: global.defaultCountry,
            state: global.defaultState,
            city: '',
            address1: '',
            additional_phone: '',
            zip: '',
            user_type: 0,
            phone_verified: 0,
            verified_phonenum: '',
            phone_verifysent: 0,
            verify_code: '',
            mail_verified: 0,
            termCheck: 0,
            status: 'active',
            phone_verified: 0,
            verified_phonenum: '',
            find_source: '',
        },
        enableReinitialize: true,
        validationSchema: validationArray[0],

        onSubmit: (values) => {
            setIsLoading(true)
            if (values.reinstate_date !== '') {
                values.reinstate_date = moment(values.reinstate_date).format(
                    'YYYY-MM-DD'
                )
            }
            if (values.license_expiry !== '') {
                values.license_expiry = moment(values.license_expiry).format(
                    'YYYY-MM-DD'
                )
            }
            if (values.license_expiry_date !== '') {
                values.license_expiry_date = moment(
                    values.license_expiry_date
                ).format('YYYY-MM-DD')
            }
            if (!single_user.record?.tax_doc_status && values.tax_doc_status) {
                values.sendAdminNotification = true
                values.sendAdminNotification_type = ['tax_doc_update']
            } else if (
                !single_user.record?.tax_doc_status &&
                values.tax_doc_status
            ) {
                values.sendAdminNotification = true
                values.sendAdminNotification_type = ['tax_doc_update']
            } else {
                values.sendAdminNotification = false
            }

            if (values.phone) {
                values.phone = formatPhone(values.phone)
            }

            if (values.additional_phone) {
                values.additional_phone = formatPhone(values.additional_phone)
            }

            // values.noReCalculate = true
            userAction(values)
        },
    })
    useEffect(() => {
        setIsLoading(false)
    }, [])
    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        if (alldata_all_dropdown.length) {
            let mapping = [...alldata_all_dropdown]
            let allCategory = []
            mapping
                .sort((a, b) => a.show_order - b.show_order)
                .map((lot, index) => {
                    if (lot.variable == 'category') {
                        allCategory.push({
                            value: lot.id.toString(),
                            show: lot.description,
                        })
                    }
                })
            setCategory(allCategory)
        }
    }, [alldata_all_dropdown])

    const validationPassword = Yup.object({
        change_password: Yup.boolean(),
        new_password: Yup.string()
            .notOneOf(
                [Yup.ref('current_password')],
                'New password must be different'
            )
            .matches(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                'Password must contain at least one lowercase letter, uppercase letter, number and special character'
            )
            .min(8, 'Minimum 8 characters')
            .required('Required'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('new_password')], 'Passwords Not Match')
            .required('Required'),
    })

    const formikPassword = useFormik({
        initialValues: {
            noCurrentCheck: true,
            change_password: 1,
            current_password: '',
            new_password: '',
            confirm_password: '',
        },
        validationSchema: validationPassword,
        onSubmit: (values) => {
            userAction(values)
            setIsLoading(true)
        },
    })

    const passwordChange = [
        {
            label: 'Password',
            name: 'new_password',
            type: 'password',
            placeholder: 'Enter your New password',
            class: 'col-md-6 col-sm-12',
        },
        {
            label: 'Confirm password',
            name: 'confirm_password',
            type: 'password',
            placeholder: 'Re enter your password',
            class: 'col-md-6 col-sm-12',
        },
    ]
    useEffect(() => {
        if (props?.userId) {
            setIsLoading(true)
            formik.values.id = props.userId ? parseInt(props.userId) : 0
            formikPassword.values.id = props.userId ? parseInt(props.userId) : 0
            getSingleUser(formik.values)
        } else {
            resetFrom()
        }
    }, [props?.userId])

    const processSwipedData = () => {
        //     const lineOneRegex =
        //         /^([A-Z]{2})([^$^]+)\^([^$^]+)\$([^$^]+)\^([^$^]+)\^/
        //     const lineTwoRegex =
        //         /^(\d{6})(\d+)=(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})$/
        //     const { line1, line2 } = swipeData
        //     const userDetails1 = String(line1 || '').match(lineOneRegex)
        //     const userDetails2 = String(line2 || '').match(lineTwoRegex)
        //     console.log('swipeData processSwipedData userDetails1', userDetails1)
        //     console.log('swipeData processSwipedData userDetails2', userDetails2)
        //     if (userDetails1) {
        //         const [_, state, city, last_name, first_name, address1] =
        //             userDetails1
        //         formik.setFieldValue('first_name', first_name)
        //         formik.setFieldValue('last_name', last_name)
        //         formik.setFieldValue('address1', address1)
        //         formik.setFieldValue('city', city)
        //         formik.setFieldValue('state', state)
        //     }
        //     if (userDetails2) {
        //         const [
        //             _,
        //             stateCode,
        //             driver_license,
        //             expiryYear,
        //             expiryMonth,
        //             dobYear,
        //             dobMonth,
        //             dobDay,
        //         ] = userDetails2
        //         formik.setFieldValue('driver_license', driver_license)
        //         formik.setFieldValue(
        //             'license_expiry_date',
        //             `20${expiryYear}-${expiryMonth}-${dobDay}`
        //         )
        //     }
    }

    const handleSwipeSuccess = (data) => {
        console.log('swipeData handleSwipeSuccess', data)
        setSwipeData(data)
    }

    const handleSwipeFailure = () => {
        console.log('swipeData handleSwipeFailure')
        setSwipeData(null)
    }

    useEffect(() => {
        CardSwipe.init({
            success: handleSwipeSuccess,
            failure: handleSwipeFailure,
            parsers: ['generic'],
            debug: true,
        })
    }, [])

    useEffect(() => {
        if (swipeData) {
            processSwipedData()
        }
    }, [swipeData])

    const parseSwipedData = (data) => {
        console.log('swipeData parseSwipedData data', data)
        data = data.replace(/Shift/g, '')
        console.log('swipeData parseSwipedData data', data)
        // data =
        //     '%MNRAMSEY^DENHAM$SHAUN$PATRICK^5555 222TH AVE NW^?;63603813519844658009=2809197709149?#00 553034126D 1073200 GRN?'
        let licenseData = String(data || '')
            .trim()
            .split(/[%\^$#?;]/)
            .filter((val) => val != '')
        let stateCity = licenseData[0]
        let zipcode = licenseData[licenseData.length - 1]
        let licenseSplit = licenseData[licenseData.length - 2].split('=')
        let address1 = licenseData[licenseData.length - 3]
        const state = stateCity.slice(0, 2)
        const expiryDate = `20${licenseSplit[1].slice(
            0,
            2
        )}-${licenseSplit[1].slice(2, 4)}-${licenseSplit[1].slice(10, 12)}`
        let driver_license = licenseSplit[0].slice(6)

        if (state === 'MN') {
            driver_license = `${String.fromCharCode(
                Number(licenseSplit[0].slice(6, 8)) + 64
            )}${licenseSplit[0].slice(8)}${licenseSplit[1].slice(-1)}`
        } else {
            setAlert(
                `Please cross-verify the driver's license number`,
                `warning`
            )
        }

        zipcode = String(zipcode || '')
            .replace(/\s+/g, '')
            .slice(2, 7)

        formik.setFieldValue('last_name', licenseData[1])
        formik.setFieldValue(
            'first_name',
            licenseData?.length > 5 ? licenseData[2] : ''
        )
        formik.setFieldValue('address1', address1)
        formik.setFieldValue('license_expiry_date', expiryDate)
        formik.setFieldValue('state', state)
        formik.setFieldValue('city', stateCity.slice(2))
        formik.setFieldValue('zip', zipcode)
        formik.setFieldValue('driver_license', driver_license)
    }

    useEffect(() => {
        let swipeTimeout

        const handleKeyDown = (event) => {
            console.log('swipeData handleKeyDown', event.key)
            if (event.key === '%' && !swipedData) {
                swipeDataRef.current = event.key
            } else if (swipeDataRef.current) {
                if (event.key === 'Enter' || event.key === '\n') {
                    parseSwipedData(swipeDataRef.current)
                    swipeDataRef.current = ''
                    setSwipedData('')
                } else {
                    swipeDataRef.current += event.key
                }

                clearTimeout(swipeTimeout)
                swipeTimeout = setTimeout(() => {
                    swipeDataRef.current = ''
                }, 200)
            }
        }

        window.addEventListener('keydown', handleKeyDown)

        return () => {
            window.removeEventListener('keydown', handleKeyDown)
            clearTimeout(swipeTimeout)
        }
    }, [swipedData])

    useEffect(() => {
        if (single_user.record && props.userId) {
            const user = single_user.record
            formik.setValues({
                id: user.id,
                first_name: user.first_name ? user.first_name : '',
                last_name: user.last_name ? user.last_name : '',
                phone: user.phone ? formatPhone(user.phone, true) : '',
                email: user.email,
                passport: user.passport ? user.passport : '',
                companyname: user.companyname ? user.companyname : '',
                identification: user.identification ? user.identification : 1,
                driver_license: user.driver_license
                    ? Cryptos.decrypt(user.driver_license)
                    : '',
                govt_photo_id: user.govt_photo_id ? user.govt_photo_id : '',
                license_expiry_date: user.license_expiry_date
                    ? user.license_expiry_date
                    : '',
                email_pref: user.email_pref ? user.email_pref : '',
                resale_certificate: user.resale_certificate
                    ? [user.resale_certificate]
                    : [],
                tax_number: user.tax_number ? user.tax_number : '',
                email_subscribe: user.email_subscribe
                    ? user.email_subscribe
                    : false,
                country: user.country ? user.country : global.defaultCountry,
                state: user.state ? user.state : global.defaultState,
                city: user.city ? user.city : '',
                address1: user.address1 ? user.address1 : '',
                additional_phone: user.additional_phone
                    ? formatPhone(user.additional_phone, true)
                    : '',
                phone_type2: user.phone_type2 ? user.phone_type2 : '',
                zip: user.zip ? user.zip : '',
                interested_categories: user?.interested_categories
                    ? user.interested_categories.split(',')
                    : [],
                reinstate_days: user?.reinstate_days ? user.reinstate_days : '',
                reinstate_date: user?.reinstate_date ? user.reinstate_date : '',
                tax_doc_status: user?.tax_doc_status ? 1 : 0,
                restocking_fee_status: user?.restocking_fee_status ? 1 : 0,
                dealer_tax_status: user.dealer_tax_status ? 1 : 0,
                is_mail_sent: user.is_mail_sent ? 1 : 0,
                ssn: user.ssn ? 1 : 0,
                dealer_certificate: user.dealer_certificate
                    ? [user.dealer_certificate]
                    : [],
                dealer_license_no: user.dealer_license_no
                    ? user.dealer_license_no
                    : '',
                license_expiry: user.license_expiry ? user.license_expiry : '',
                find_source: user.find_source ? user.find_source : '',
            })
            // setTimeout(() => {
            //     setInitialLoad(true)
            // }, 3000)
            // console.log(
            //     moment(user?.reinstate_date).format('YYYY-MM-DD'),
            //     'reinstate date'
            // )
        } else {
            resetFrom()
        }
        setIsLoading(false)
    }, [single_user])

    const resetFrom = () => {
        formik.values.email = ''
        formik.values.first_name = ''
        formik.values.last_name = ''
        formik.values.phone = ''
        formik.values.companyname = ''
        formik.values.id = 0
        formik.values.tax_doc_status = 0
        formik.values.restocking_fee_status = 0
        formik.values.reinstate_days = ''
        formik.values.reinstate_date = ''
        formik.values.is_mail_sent = 0
        formik.values.ssn = 0
        formik.values.resale_certificate = []
        formik.values.tax_number = ''
        formik.values.email_subscribe = false
        formik.values.country = global.defaultCountry
        formik.values.state = global.defaultState
        formik.values.address1 = ''
        formik.values.additional_phone = ''
        formik.values.city = ''
        formik.values.zip = ''
        formik.values.find_source = ''
        formik.handleReset()
        setIsLoading(false)
    }

    const IndividualRegistration = {
        formik: formik,
        data: [
            {
                label: 'First Name' + '*',
                name: 'first_name',
                type: 'text',
                placeholder: 'Enter Your First Name',
                class: 'col-12 col-sm-6',
                autoFocus: true,
            },
            {
                label: 'Last Name' + '*',
                name: 'last_name',
                type: 'text',
                placeholder: 'Enter Your Last Name',
                class: 'col-12 col-sm-6',
            },
        ],
    }

    if (props?.userStatus === 'new') {
        IndividualRegistration.data.push(
            {
                label: 'Email address' + '*',
                name: 'email',
                type: 'email',
                placeholder: 'Enter Your Email Address',
                class: 'col-12 col-sm-6',
            },
            {
                label: 'Confirm Email Address' + '*',
                name: 'confirm_email',
                type: 'email',
                placeholder: 'Enter Your Email Address',
                class: 'col-12 col-sm-6',
            }
        )
    } else {
        IndividualRegistration.data.push({
            label: 'Email Address' + '*',
            name: 'email',
            type: 'email',
            // disabled: true,
            placeholder: 'Enter Your Email Address',
            class: 'col-12 col-sm-6',
        })
    }
    IndividualRegistration.data.push(
        {
            label: 'Company / Organization',
            name: 'companyname',
            type: 'text',
            placeholder: 'Enter your Company / Organization name',
            class: 'col-12 col-sm-6',
        },
        {
            label: 'Mobile number' + '*',
            name: 'phone',
            type: 'number',
            placeholder: 'Mobile number',
            class: 'col-12 col-sm-4',
        },
        {
            label: 'Additional Phone number',
            name: 'additional_phone',
            type: 'number',
            placeholder: 'Mobile number',
            countryCodeEditable: false,
            class: 'col-12 col-sm-4',
        },
        {
            label: 'Address' + '*',
            name: 'address1',
            type: 'text',
            placeholder: 'Enter your address',
            class: 'col-12 col-sm-6',
        },
        {
            label: 'City' + '*',
            name: 'city',
            type: 'text',
            placeholder: 'Enter your city',
            class: 'col-12 col-sm-6',
        },
        {
            label: 'State' + '*',
            placeholder: 'Select your state',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allStates
                .filter(
                    (state) =>
                        (formik.values.country
                            ? formik.values.country.indexOf(
                                  state.countryCode
                              ) !== -1
                            : global.defaultCountry.indexOf(
                                  state.countryCode
                              ) !== -1) &&
                        global.ignoreStates.indexOf(state.isoCode) === -1
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'state',
        },

        {
            label: 'Country' + '*',
            placeholder: 'Select your country',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allCountries
                .filter(
                    (country) =>
                        global.ignoreCountry.indexOf(country.isoCode) === -1
                )
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'country',
        },
        {
            label: 'Zip code' + '*',
            placeholder: 'Enter your zip code',
            class: 'col-12 col-sm-6',
            type: 'text',
            name: 'zip',
        },
        {
            label: 'Resale Number',
            name: 'tax_number',
            type: 'text',
            placeholder: 'Enter your Resale Number',
            class: `col-12 col-sm-6`,
        },
        {
            type: 'uploadDropZone',
            name: 'resale_certificate',
            icon: 'description',
            titleText: 'Resale Document',
            innerText: 'Resale Document',
            class: `col-12 ${formik?.values.tax_number !== '' ? '' : 'd-none'}`,
            folder: 'tax_file',
            multiple: true,
            accept: 'image/*, application/*',
        },
        {
            label: 'Resale Exemption Verified',
            type: 'checkbox',
            name: 'tax_doc_status',
            class: 'col-6',
        },
        // {
        //     label: 'Restocking Fee Applied',
        //     type: 'checkbox',
        //     name: 'restocking_fee_status',
        //     class: 'col-6',
        // },
        {
            label: 'How Did You Find Us?',
            placeholder: 'Select',
            class: 'col-12 col-sm-6 howFind',
            type: 'select',
            options: [
                { show: 'Facebook', value: 'Facebook' },
                { show: 'Instagram', value: 'Instagram' },
                { show: 'Twitter', value: 'Twitter' },
                { show: 'Google', value: 'Google' },
                { show: 'Staff Member', value: 'Staff Member' },
                { show: 'Word of Mouth', value: 'Word of Mouth' },
                { show: 'Other', value: 'Other' },
            ],
            name: 'find_source',
        }
    )

    if (props?.userId && single_user?.record?.status === 'deactivate') {
        IndividualRegistration.data.push(
            {
                type: 'misc',
                content: 'Reinstate',
                class: 'col-md-12 mb-2',
            },
            {
                label: 'Time Limit',
                placeholder: 'Select Time Limit',
                class: `col-12 col-sm-6`,
                type: 'select',
                name: 'reinstate_days',
                options: [
                    { value: '30', show: '30 Days' },
                    { value: '90', show: '90 Days' },
                    { value: '180', show: '180 Days' },
                    { value: 'Never', show: 'Never' },
                ],
            },
            {
                label: 'Activation Date',
                placeholder: 'Enter Activation Date',
                class: `col-12 col-sm-6`,
                type: 'date',
                name: 'reinstate_date',
                disabled:
                    formik.values.reinstate_days == 'Never' ? true : false,
            }
        )
    }
    useEffect(() => {
        if (formik.values.reinstate_days == 'Never') {
            formik.values.reinstate_date = ''
        } else if (formik.values.reinstate_days !== '') {
            let endDate = new Date()
            endDate.setDate(
                endDate.getDate() + parseInt(formik.values.reinstate_days)
            )
            formik.values.reinstate_date =
                endDate.getFullYear() +
                '-' +
                (parseInt(endDate.getMonth()) + 1) +
                '-' +
                endDate.getDate()
        }
    }, [formik.values.reinstate_days])
    // useEffect(() => {
    //     if (single_user?.record?.id && initialLoad) {
    //         changeChangeStatus()
    //     }
    // }, [formik.values.restocking_fee_status])

    const submitFn = () => {
        restockingFeeUpdate({
            user_id: [single_user?.record?.id],
            restocking_fee_status: formik.values.restocking_fee_status,
        })
    }
    const formSubmit = (e) => {
        formik.handleSubmit(e)
        console.log(formik.errors)
    }

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'userAction') {
                formik.setSubmitting(false)
                setIsLoading(false)
                if (props.userId) getSingleUser(formik.values)
                if (props.cancelFunction && props.userStatus == 'new') {
                    props.cancelFunction()
                }
            }
        }
    }, [responseStatusUser])

    useEffect(() => {
        if (responseStatusAuth) {
            if (responseStatusAuth.from === 'updateProfile') {
                formikPassword.setSubmitting(false)
                setIsLoading(false)
            }
        }
    }, [responseStatusAuth])
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    // const simulateSwipe = () => {
    //     const swipeData = `%MNRAMSEY^DENHAM$SHAUN$PATRICK^5555 222TH AVE NW^?;63603813519844658009=2809197709149?#00 553034126D 1073200 GRN?\n`
    //     const inputDelay = 1 // Simulate fast key press intervals

    //     console.log('swipeData simulateSwipe', swipeData)
    //     swipeData.split('').forEach((char, index) => {
    //         setTimeout(() => {
    //             const event = new KeyboardEvent('keydown', { key: char })
    //             window.dispatchEvent(event)
    //         }, inputDelay * index)
    //     })
    //     console.log('swipeData simulateSwipe FINISHED')
    // }

    return (
        // <FullScreenPopup
        //     modaltitle={
        //         data.status === 'new'
        //             ? 'ADD NEW CUSTOMER'
        //             : `EDIT CUSTOMER: ${single_user.record.first_name || ''} ${
        //                   single_user.record.last_name || ''
        //               }`
        //     }
        //     open={data.popup == 'Comment' ? false : data.popup}
        //     handleClose={() => toggleFullScreenPopup(false)}
        // >
        <div className="addUserModal">
            <div className="fspBody">
                {formik.isSubmitting ? <LinearProgress /> : null}
                {isLoading ? (
                    <div className="fspLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    <>
                        <CustomDialog
                            title={'Confirm'}
                            open={changeStatus}
                            function={changeChangeStatus}
                        >
                            <h5>{`Are you sure you want to ${
                                formik.values.restocking_fee_status
                                    ? 'add'
                                    : 'remove'
                            } restocking fees for this user ?`}</h5>
                            <div className="actionWrapper">
                                <Button
                                    id="location_cancel"
                                    onClick={() => changeChangeStatus()}
                                >
                                    Cancel
                                </Button>

                                <PrimaryButton
                                    id="location_confirm"
                                    onClick={submitFn}
                                    label="Confirm"
                                />
                            </div>
                        </CustomDialog>
                        {formik.values.id ? (
                            <div className="relistedInfoCnt">
                                <>
                                    <span className="material-icons-outlined">
                                        info
                                    </span>{' '}
                                    <div className="relistedInfoInner">
                                        <h5 className="relistedInfo">
                                            <span>Bidder Number:</span>
                                            {formik.values.id}
                                        </h5>
                                    </div>
                                </>
                            </div>
                        ) : null}

                        <form onSubmit={formSubmit} autoComplete="nofill">
                            <div>
                                {/* <h2 className="dashTitle">INDIVIDUAL</h2> */}
                                <div className="row">
                                    {Object.values(
                                        mapData(IndividualRegistration)
                                    )}
                                </div>
                            </div>
                            <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                {/* {data.status != 'new' && (
                                <div className="mr-auto">
                                    <SecondaryButton
                                        label="Reset Password"
                                        onClick={() =>
                                            forgotPassword({
                                                email: formik.values.email,
                                            })
                                        }
                                    />
                                </div>
                            )} */}
                                <SecondaryButton
                                    label="Cancel"
                                    onClick={() => props.cancelFunction()}
                                />
                                <PrimaryButton
                                    type="submit"
                                    label={
                                        props?.userStatus == 'new'
                                            ? 'Submit'
                                            : 'Update'
                                    }
                                />
                            </div>
                        </form>
                        {/* <button
                            onClick={() => {
                                simulateSwipe()
                            }}
                        >
                            Simulate Swipe
                        </button> */}
                        {props.userId &&
                        (user?.emp_type === 'super_admin' ||
                            user?.emp_type === 'admin') ? (
                            <>
                                <form
                                    onSubmit={formikPassword.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <h2 className="dashTitle">
                                        CHANGE PASSWORD
                                    </h2>
                                    <div className="row">
                                        {mapData({
                                            formik: formikPassword,
                                            data: passwordChange,
                                        })}
                                    </div>
                                    <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                        <PrimaryButton
                                            id="employee_submit"
                                            type="submit"
                                            label="Submit"
                                        />
                                    </div>
                                </form>
                            </>
                        ) : null}
                    </>
                )}
            </div>
        </div>
        // </FullScreenPopup>
    )
}

export default UserManage
